import React, { useState } from 'react';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';
import { fetchAbandonedOrder } from './helpers';
import OrderReportsTable from './OrderReportsTable';

const OrderReports = () => {
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalSize, setTotalSize] = useState(0);

  const [loading, setLoading] = useState(false);

  const [orderReference, setOrderReference] = useState('');

  const [ordersData, setOrdersData] = useState(null);

  React.useEffect(() => {
    let ignore = false;
    const fetchFunc = async () => {
      try {
        setLoading(true);
        const ordersDataResponse = await fetchAbandonedOrder({
          orderReference,
          from: currentPage * 50,
          size: 50,
        });
        setTotalPages(ordersDataResponse?.total_pages);
        setTotalSize(ordersDataResponse?.total_size);
        if (!ignore && ordersDataResponse && currentPage === 0) {
          setOrdersData(ordersDataResponse.abandoned_order_listing);
        } else if (!ignore && ordersDataResponse) {
          setOrdersData([
            ...ordersData,
            ...ordersDataResponse.abandoned_order_listing,
          ]);
        }
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };

    fetchFunc();

    return () => {
      ignore = true;
    };
  }, [orderReference, currentPage]);

  const loadMoreDataFunc = () => {
    if (totalPages <= currentPage + 1) {
      // pass
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <Layout>
      <Header />
      <Search
        orderReference={orderReference}
        setOrderReference={e => {
          setOrderReference(e.target.value);
          setCurrentPage(0);
        }}
      />
      <>
        {!!totalSize && (
          <div className="level-left p-4">
            <div className="level-item">
              <p className="subtitle is-4">
                <strong>{totalSize} row(s)</strong>
              </p>
            </div>
          </div>
        )}
        <OrderReportsTable
          loading={loading}
          loadMoreData={loadMoreDataFunc}
          orderReportsData={ordersData}
        />
      </>
    </Layout>
  );
};

export default OrderReports;
